import type { AnimatePresenceProps } from "framer-motion";
import { AnimatePresence as _AnimatePresence, motion } from "framer-motion";
import type { FC, PropsWithChildren } from "react";

const AnimatePresence = _AnimatePresence as FC<
  PropsWithChildren<AnimatePresenceProps>
>;

export { AnimatePresence, motion };
